// extracted by mini-css-extract-plugin
export var content = "index-v2-module--content--3d50d";
export var image = "index-v2-module--image--b6480";
export var info = "index-v2-module--info--5c761";
export var speechBubble = "index-v2-module--speechBubble--3e9ed";
export var wrapper = "index-v2-module--wrapper--ff915";